<template>
  <div class="notice-bar" v-if="text">
    <div class="notice-bar__track">
      <span class="notice-bar__text">{{ text }}</span>
      <span class="notice-bar__text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
import { fetchNoticeList } from '@/api/notice'

export default {
  name: 'NoticeBar',
  data() {
    return { text: '' }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      try {
        const siteId = process.env.VUE_APP_SITE_ID || 'default'
        const res = await fetchNoticeList(siteId)
        const data = res.data
        const list = Array.isArray(data) ? data : (data && Array.isArray(data.data) ? data.data : [])
        this.text = list.map(n => n.content).join(' ｜ ')
        const domain = list.find(n => n.siteDomain)?.siteDomain || ''
        this.$emit('domain-loaded', domain)
      } catch (e) {
        // silent
      }
    }
  }
}
</script>

<style scoped>
.notice-bar {
  margin: 0 0 clamp(0.375rem, 2vw, 0.5rem);
  padding: clamp(0.375rem, 2vw, 0.5rem) 0;
  background: linear-gradient(90deg, #fff8e1, #fff3e0);
  border-radius: clamp(0.35rem, 1.5vw, 0.5rem);
  overflow: hidden;
  white-space: nowrap;
  border: 1px solid #ffe0b2;
}
.notice-bar__track {
  display: inline-block;
  animation: notice-scroll 12s linear infinite;
}
.notice-bar__text {
  font-size: clamp(0.875rem, 3vw, 1rem);
  color: #e65100;
  font-weight: 500;
  padding-right: 2rem;
}
@keyframes notice-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>
